import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import OrganizerFileIcon from "../../organizer/view/OrganizerFileIcon";

/**
 * ManuscriptBlockType: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Content block type info displaying icon and
 * text
 *
 * @param {*} props
 */
const ManuscriptBlockType = ({ type }) => (
  <div className="ed-block-type">
    <OrganizerFileIcon block documentType={type} size={16} />
    <span>
      <FormattedMessage
        id={`manuscript.${type}.title`}
        description="Manuscript block type title"
      />
    </span>
  </div>
);

ManuscriptBlockType.propTypes = {
  type: PropTypes.string.isRequired
};

export default ManuscriptBlockType;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptBlockType.js